<template>
  <v-dialog v-model="model" :max-width="showQrCode?'780px':'650px'">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('StaffDeviceQRCode.QRCode')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container v-if="showQrCode">
        <v-row class="pr-0">
          <v-col cols="12">
            <div class="d-flex justify-center">
              <QRcode :size="700" :value="qrCode" />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="10" offset="1">
            <v-card-text class="pt-5">
              <span class="text-h6 font-weight-light">
                {{$t('StaffDeviceQRCode.PleaseEnterYourPasswordToReceiveTheQrCode')}}
              </span>
              <validation-observer ref="observer" v-slot="{ invalid }">
                <v-form
                  ref="verifyPasswordForm"
                  lazy-validation
                  id="verify-password-form"
                  @submit.prevent="verifyPassword"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <v-text-field
                      :label="$t('StaffDeviceQRCode.Password')"
                      type="password"
                      class="mt-4"
                      :error-messages="errors"
                      v-model="form.password"
                    />
                  </validation-provider>
                  <div class="d-flex justify-center">
                    <v-btn
                      color="primary"
                      type="submit"
                      :disabled="invalid || loading"
                      :loading="loading"
                      >{{$t('GeneralTranslations.Ok')}}</v-btn
                    >
                  </div>
                </v-form></validation-observer
              >
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import firebase from "firebase";
  import QRcode from "v-qrcode/src/index.vue";
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import { mapState } from "vuex";

  export default {
    name:"StaffDeviceQRCode",
    components: {
      QRcode,
      ValidationObserver,
      ValidationProvider
    },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.authModule.user
      }),
      model: {
        get() {
          return this.value;
        },
        set() {
          this.$emit("close");
        }
      },
      qrCode() {
        return `${this.user.email}|${this.form.password}`;
      }
    },
    data() {
      return {
        showQrCode: false,
        form: {
          password: ""
        },
        loading: false
      };
    },
    methods: {
      close() {
        this.$emit("close");
      },
      async verifyPassword() {
        this.loading = true;
        this.$refs.observer.validate();

        try {
          await firebase.auth().signInWithEmailAndPassword(this.user.email, this.form.password);
          this.showQrCode = true;
        } catch (e) {
          this.$refs.observer.setErrors({
            Password: ["Invalid password"]
          });
        }

        this.loading = false;
      }
    }
  };
</script>

<style src="./StaffDeviceQRCode.scss" lang="scss" scoped></style>

